import {Deserializable} from "./deserializable.model";

export class Brand {

  brand_id?: number;
  name?: string;
  profile?: string;
  sef_name?: string;
  keywords?: string;
  logo?: string;
  phone?: string;
  fax?: string;
  email?: string;
  website?: string;
  listing_cat_id?: number;
  brand_id__?: number;
  is_active?: string;
  created?: string;
  updated?: string;
  created_by?: number;
  updated_by?: number;
  is_represented?: string;
  address?: string;
  main_listing?: string;
  address_1?: string;
  address_2?: string;
  suburb?: string;
  state?: string;
  postcode?: string;
  country?: string;
  custom_report_pdf?: string;
  report_logo?: string;
  report_cover_bg?: string;
  report_general_bg?: string;
  report_colour_base?: string;
  brand_type_id?: number;
  brand_notes?: string;
myob_id?: string;
postal_address_1?: string;
postal_address_2?: string;
postal_suburb?: string;
postal_state?: string;
postal_country?: string;
qualification?: string;
qualification_number?: string;
qualification_renewal_date?: string;
accounts_email_address?: string;
postal_postcode?: number;
sync_with_myob?: any;

//
create_primary_contact?: number;
// Primary Contact Vars
first_name?: string;
surname?: string;
email_address?: string;
mobile?: string;
// a company/brand as an agent can have a persons full name october 2022
middle_name?;

IsIndividual?;
SaleLayout?;
InvoiceDelivery?;
TaxCode?;
FreightTaxCode?;
RowVersion?;
myob_customer_array?;


global_key_hash?: string;
global_key_expiry_date?: string;
global_key_expiry_token?: string;
global_key_expiry_token_date?: string;

from_brand_name?: string;
to_brand_name?: string;
created_date_from?: any;
created_date_to?: string;
updated_date_from?: any;
updated_date_to?: string;
access_level?;
myob_sync_status?: number;
to_brand_id?;

abn?;
is_tfa_enforced?;

user_ui_layout_id?;
is_client_show_agent_level?;

personal_email_address?;
send_welcome_email?;
  // ? what does this really do? (no encoding or deserialisation required...)
  // deserialize(input: any): Brand {
  //   // Object.assign(this, input);

  //   return this;
  // }


}
